import type { SchoolOverview } from "../overviewTypes";
import MetricValue from "./MetricValue";

export default function Priorities({ priorities, standardAchieved }: { priorities: SchoolOverview["priorities"]; standardAchieved: boolean | null }) {
  return <section aria-labelledby="priorities-title">
    <h3 id="priorities-title" className="font-semibold text-pd-ink">Priorities</h3>
    <ul className="ml-0 list-none p-0 mt-3 grid gap-4 md:grid-cols-3">
      {priorities.map(priority => <li key={priority.id} className="min-w-0 border-l-2 border-pd-rule pl-3 text-sm text-pd-ink">
        <p className="font-semibold">{priority.label}</p>
        {priority.value ? <p className="mt-1 text-pd-slate"><MetricValue metric={priority.value} /></p> : null}
        {priority.id === "core" ? <p className="mt-1 text-pd-slate">{standardAchieved === null ? "Whole-school Standard status is withheld." : standardAchieved ? "Whole-school Pedagogue AI Standard achieved." : "Working towards the whole-school Pedagogue AI Standard."}</p> : null}
        {priority.departments?.map(department => <p key={department.label} className="mt-1 break-words text-pd-slate">{department.label}: <MetricValue metric={department.value} /></p>)}
      </li>)}
    </ul>
  </section>;
}
